/**
 * @fileoverview TextRenderer component for the Storyteller web application.
 * Renders a text element with i18n support.
 *
 * @example
 * // Basic usage
 * <TextRenderer
 *   schema={{
 *     type: 'string',
 *     options: { text: 'Hello, World!' }
 *   }}
 *   path="text"
 *   handleChange={(path, value) => console.log(path, value)}
 * />
 */

import { LabelProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { useJsonForms, withJsonFormsLabelProps } from '@jsonforms/react'
import { VanillaRendererProps, withVanillaControlProps } from '@jsonforms/vanilla-renderers'
import { useTranslation } from 'react-i18next'
import { Text } from '../../../typography/Typography'

/**
 * @function TextRenderer
 * @description Component for rendering a text element with i18n support.
 * @param {LabelProps & VanillaRendererProps} props - The props for the TextRenderer component.
 * @returns {JSX.Element} The TextRenderer component.
 */
function TextRenderer(props: LabelProps & VanillaRendererProps) {
    const { core } = useJsonForms()
    const { text } = props
    const { t } = useTranslation()
    return <Text>{t(text, core.data as Record<string, unknown> | undefined)}</Text>
}

export const TextTester = rankWith(3, uiTypeIs('Text'))

export default withVanillaControlProps(withJsonFormsLabelProps(TextRenderer))
